export default "__VITE_ASSET__Cq1Ed1NV__"